var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticStyle:{"margin":"1.5vh"},attrs:{"type":"text","label":_vm.label || _vm.$t('button.search'),"append-icon":"mdi-magnify","single-line":"","hide-details":""}},'v-text-field',{..._vm.$attrs, ..._vm.$props},false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }